import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fade,
  IconButton,
  Typography,
} from '@material-ui/core';
import './index.scss';
import CloseIconModal from 'assets/icons/CloseIconModal';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { Row } from 'components/Row';
import { Col } from 'components/Col';
import { CustomTextField } from 'components/CustomTextField';
import { CustomCheckbox } from 'components/CustomCheckbox';
import useValidations from 'pages/Contratos/Fluxos/FluxoDescentralizados/hooks/useValidations';
import moment from 'moment';
import { DateMaskedInput } from 'components/MaskedInputs';
import SnackbarUtils from 'utils/SnackbarUtils';
import {
  CONTRATO_ETAPAS_PARAMS_URL,
  CONTRATO_PASSOS,
  CONTRATO_FLUXO_DESCENTRALIZADO,
  ContratoStatus,
  URL_DISTRATO_PARAM,
  VersaoContratoEnum,
  TipoContrato,
  URL_ENTE_DESCENTRALIZADO,
} from 'models/contratos';
import ModalConfirm from 'pages/Contratos/components/ModalConfirm';
import { openModal } from 'store/modules/ModalActions';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { newContratoDescentralizadoEditRoute } from 'library/Routes';
import {
  CreateRouteParams,
  EditRouteParams,
} from 'pages/Contratos/Fluxos/FluxoDescentralizados/__types';
import { changeContratoEntePublicoEditingValue, closeModalEntePublicoDistrato, contratoEntePublicoDescentralizadoCreateDistrato, contratoEntePublicoDescentralizadoEditDistrato, loadContratoEntePublico } from 'store/modules/ContratosFluxoDescentralizado/EntePublico/EntePublicoActions';
import { NewAutoCompleteField } from 'components/NewAutoCompleteField';
import { loadCidadesByEstadoId } from 'store/modules/LogradouroActions';
import { loadContratoAdendos } from 'store/modules/AllContratos/AllContratosActions';
interface Cidade {
  nome: string;
}

const ModalDistratoEntePublico = () => {
  const [cidadesCarregadas, setCidadesCarregadas] = useState<{ [key: string]: boolean }>({});
  const [dataError, setDataError] = useState('');
  const [, setIdEstadoChanged] = useState(false);
  const languageValues = useSelector(
    (state: RootState) => state.languages.languageValues
  );
  const contratosEntePublicoReducer = useSelector(
    (state: RootState) => state.contratosDescentralizadosEntePublico
  );
  const adendosAll = useSelector(
    (state: RootState) => state.allContratos.adendosAll
  );
  const adendoVersaoContratoUm = adendosAll.find(
    (adendo) => adendo.versaoContrato === 1
  );
  const idVersaoContrato = adendoVersaoContratoUm
    ? adendoVersaoContratoUm?.id
    : null;
  const logradouro = useSelector((state: RootState) => state.logradouro);
  const {
    validDadosEntePublicoDistrato,
    validateDateDistrato,
    desabilitaCampoEspecificoAditivoEDistrato,
    isContratoAtivoEntePublico,
    validaStatusContratoFluxo,
    desabilitaCampoCidade,
  } = useValidations();
  const location = useLocation();
  const history = useHistory();
  const params = useParams<CreateRouteParams & EditRouteParams>();
  const dispatch = useDispatch();
  const fluxoEntePublico = location.pathname.includes(URL_ENTE_DESCENTRALIZADO.ENTE_PUBLICO);

  const handleDataChange = useCallback(
    (name, value) => {
      dispatch(changeContratoEntePublicoEditingValue(name, value));
    },
    [dispatch]
  );

  const getUFByIdEstado = (idEstadoParam: number | null): string => {
    const estadoV = logradouro.estados.find((estado) => estado.id === idEstadoParam);
    return estadoV ? estadoV.sigla : '';
  };

  const getCidades = (uf: string): Cidade[] => {
    if (!uf) {
      return [];
    }
    return logradouro.cidades[uf.toLowerCase()] || [];
  };

  const loadCidades = (idEstado: number) => {
    const uf = getUFByIdEstado(idEstado);
    if (uf && getCidades(uf).length === 0) {
      dispatch(loadCidadesByEstadoId(idEstado, uf));
    }
  };

  const fechaModalEAtualizaContrato = () => {
    history.push(
      newContratoDescentralizadoEditRoute.getURLWithParams(
        CONTRATO_FLUXO_DESCENTRALIZADO.ENTE_PUBLICO,
        CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
        idVersaoContrato,
        CONTRATO_PASSOS.DOCUMENTOS
      )
    );
    dispatch(closeModalEntePublicoDistrato());
  };

  const verificaSeTemDistrato = () => {
    return adendosAll.some(
      (item) => item.versaoContrato === VersaoContratoEnum.DISTRATO
    );
  };
  const contenDistrato = verificaSeTemDistrato();

  const abreModalCriacaoDistrato = () => {
    const fechaModal = !desabilitaCampo();
    const status = contratosEntePublicoReducer.contratoEditing.flgStatus;

    if (fechaModal) {
      fechaModalEAtualizaContrato();
      return;
    }
    else if (status === ContratoStatus.EM_EDICAO && contenDistrato === true) {
      enviaDistrato();
      fechaModalEAtualizaContrato();
      return;
    }
    dispatch(
      openModal(ModalConfirm, {
        title: languageValues.criacaoDistrato,
        content: languageValues.confirmarCriacaoDistrato,
        confirmLabel: languageValues.confirmar,
        confirmCallback: () => {
          enviaDistrato();
        },
        modalKey: 'modalComplete',
        maxWidth: 'sm',
      })
    );
  };

  const renderizaTituloModal = () => {
    const status = contratosEntePublicoReducer.contratoEditing.flgStatus;
    const url = window.location.href;

    if (url.includes(URL_DISTRATO_PARAM.EDICAO_DISTRATO) &&
      (status === ContratoStatus.VIGENTE || status === ContratoStatus.NAO_INICIADO)) {
      return `${languageValues.distrato}`;
    }
    else if (url.includes(URL_DISTRATO_PARAM.EDICAO_DISTRATO)) {
      return `${languageValues.editarDistrato}`;
    }
    return languageValues.criacaoDistrato;
  };

  const desabilitaCampo = () => {
    const isCriacao = location.pathname.includes(
      URL_DISTRATO_PARAM.CADASTRO_DISTRATO
    );
    const { flgStatus, flgAtivo } = contratosEntePublicoReducer.contratoEditing;

    if (
      !flgAtivo || (!isCriacao && (flgStatus === ContratoStatus.ENCERRADO ||
        flgStatus === ContratoStatus.VIGENTE || flgStatus === ContratoStatus.NAO_INICIADO))
    ) {
      return false;
    }
    return true;
  };

  const enviaDistrato = async () => {
    const isEdicaoDistrato = location.pathname.includes(
      URL_DISTRATO_PARAM.EDICAO_DISTRATO
    );
    const isCriacao = location.pathname.includes(
      URL_DISTRATO_PARAM.CADASTRO_DISTRATO
    );
    const distratoData = {
      idContrato: idVersaoContrato,
      idEstado: contratosEntePublicoReducer.contratoEditing.idEstado,
      nomCidade: contratosEntePublicoReducer.contratoEditing.nomCidade,
      dataDistrato: moment(contratosEntePublicoReducer.contratoEditing.dataDistrato, 'DD MM YYYY').format('YYYY-MM-DD'),
      flgAnaliseJuridica:
        contratosEntePublicoReducer.contratoEditing.flgAnaliseJuridica,
      tipoContrato: contratosEntePublicoReducer.contratoEditing.tipoContrato
    };
    const data = { ...distratoData };

    try {
      data.tipoContrato = TipoContrato.ENTE_PUBLICO

      if (isEdicaoDistrato) {
        dispatch(
          contratoEntePublicoDescentralizadoEditDistrato(
            Number(params.idDistrato),
            data,
            () => {
              SnackbarUtils.enqueueSnackbar({
                message: languageValues.successContratoDistratoAtualizar,
                options: {
                  variant: 'success',
                },
              });
              fechaModalEAtualizaContrato();
            },
            (error) => {
              const errorMessage = error.response?.data?.message;
              SnackbarUtils.enqueueSnackbar({
                message: errorMessage,
                options: {
                  variant: 'error',
                },
              });
            }
          )
        );
      } else if (isCriacao && (contenDistrato || !contenDistrato)) {
        dispatch(
          contratoEntePublicoDescentralizadoCreateDistrato(
            data,
            () => {
              SnackbarUtils.enqueueSnackbar({
                message: languageValues.successContratoDistratoSalvar,
                options: {
                  variant: 'success',
                },
              });
              fechaModalEAtualizaContrato();
              dispatch(loadContratoAdendos(idVersaoContrato));
            },
            (error) => {
              const errorMessage = error.response?.data?.message;
              SnackbarUtils.enqueueSnackbar({
                message: errorMessage,
                options: {
                  variant: 'error',
                },
              });
            }
          )
        );
      }
    } catch (error) {
      SnackbarUtils.enqueueSnackbar({
        message: error,
        options: {
          variant: 'error',
        },
      });
    }
  };

  useEffect(() => {
    if (fluxoEntePublico &&
      (location.pathname.includes(URL_DISTRATO_PARAM.CADASTRO_DISTRATO) ||
        location.pathname.includes(URL_DISTRATO_PARAM.MODAL_CRIACAO_DISTRATO))) {
      dispatch(loadContratoEntePublico(Number(params.id), VersaoContratoEnum.CONTRATO));
    }
    // eslint-disable-next-line 
  }, [dispatch,
    location.pathname])

  useEffect(() => {
    if (fluxoEntePublico &&
      (location.pathname.includes(URL_DISTRATO_PARAM.MODAL_EDICAO_DISTRATO) ||
        location.pathname.includes(URL_DISTRATO_PARAM.EDICAO_DISTRATO))) {
      dispatch(loadContratoEntePublico(Number(params.idDistrato), VersaoContratoEnum.DISTRATO));
    }
    // eslint-disable-next-line
  }, [
    dispatch,
    location.pathname]);

  useEffect(() => {
    if (fluxoEntePublico &&
      (location.pathname.includes(URL_DISTRATO_PARAM.MODAL_EDICAO_DISTRATO) ||
        location.pathname.includes(URL_DISTRATO_PARAM.MODAL_CRIACAO_DISTRATO) ||
        location.pathname.includes(URL_DISTRATO_PARAM.EDICAO_DISTRATO) ||
        location.pathname.includes(URL_DISTRATO_PARAM.CADASTRO_DISTRATO)
      )) {
      const carregaCidades = (estadoId: number, estadoUf: string) => {
        if (estadoUf && !cidadesCarregadas[estadoUf]) {
          dispatch(loadCidadesByEstadoId(estadoId, estadoUf));
          setCidadesCarregadas(prev => ({ ...prev, [estadoUf]: true }));
        }
      };
      const estadoIdV = contratosEntePublicoReducer.contratoEditing.idEstado;
      const estadoUfV = getUFByIdEstado(estadoIdV);
      carregaCidades(estadoIdV, estadoUfV);
    }
    // eslint-disable-next-line 
  }, [contratosEntePublicoReducer.contratoEditing.idEstado, dispatch, location.pathname]);

  return (
    <>
      <Dialog
        open={contratosEntePublicoReducer.isModalDistratoOpen}
        aria-labelledby='form-dialog-distrato'
        className='form-dialog-distrato'
        TransitionComponent={Fade}
        transitionDuration={{
          enter: 350,
        }}
        PaperProps={{
          style: {
            boxShadow: 'none',
          },
        }}
      >
        <DialogTitle className='form-dialog-distrato__title-modal'>
          <div className='form-dialog-distrato__titleContainer'>
            <Typography className='form-dialog-distrato__titleModal'>
              {renderizaTituloModal()}
            </Typography>
            <IconButton
              aria-label='close'
              className='form-dialog-distrato__closeButton'
              onClick={() => fechaModalEAtualizaContrato()}
            >
              <CloseIconModal />
            </IconButton>
          </div>
          <div className='form-dialog-distrato__titleLine'></div>
        </DialogTitle>
        <DialogContent>
          <Box className='form-dialog-distrato__box'>
            <Card className='form-dialog-distrato__card'>
              <Box>
                <Row>
                  <Col cols={[12, 12, 12, 12, 12]}>
                    <Typography
                      variant='h5'
                      id='dadosEntePublico'
                      className='form-dialog-distrato__tipo-contrato-title'
                    >
                      {languageValues.cadastroContratoDadosEntePublico}
                    </Typography>
                  </Col>
                </Row>
                <Row>
                  <Col cols={[12, 6, 6, 6, 6]}>
                    <NewAutoCompleteField
                      id="estado"
                      label={languageValues.estado}
                      placeholder={
                        logradouro.loadingAllEstadosByCoops
                          ? languageValues.loadingEstados
                          : ''
                      }
                      options={logradouro.estados.map((item) => ({
                        label: item.nome,
                        value: item.id,
                        sigla: item.sigla,
                      }))}
                      value={contratosEntePublicoReducer.contratoEditing.idEstado}
                      onChange={(value: { value: number }) => {
                        const currValue = value && value.value > -1 ? value.value : -1;
                        setIdEstadoChanged(true);
                        handleDataChange('idEstado', currValue);
                        loadCidades(currValue);
                      }}
                      loading={logradouro.loadingAllEstadosByCoops}
                      loadingMessage={languageValues.loadingEstados}
                      disabled={
                        !isContratoAtivoEntePublico() ||
                        !validaStatusContratoFluxo() ||
                        !desabilitaCampoEspecificoAditivoEDistrato()
                      }
                    />
                  </Col>
                  <Col cols={[12, 6, 6, 6, 6]}>
                    <NewAutoCompleteField
                      id="cidade"
                      label={languageValues.cidade}
                      placeholder={
                        logradouro.loadingCidades
                          ? languageValues.loadingCidades
                          : ''
                      }
                      options={getCidades(
                        getUFByIdEstado(
                          contratosEntePublicoReducer.contratoEditing.idEstado
                        )
                      ).map((item) => ({
                        label: item.nome,
                        value: item.nome,
                      }))}
                      value={contratosEntePublicoReducer.contratoEditing.nomCidade}
                      onChange={(value: { value: string }) => {
                        const currValue = value ? value.value : '';
                        setIdEstadoChanged(true);
                        handleDataChange('nomCidade', currValue);
                      }}
                      loading={logradouro.loadingCidades}
                      loadingMessage={languageValues.loadingCidades}
                      disabled={
                        !isContratoAtivoEntePublico() ||
                        !validaStatusContratoFluxo() ||
                        desabilitaCampoCidade(contratosEntePublicoReducer.contratoEditing.idEstado < 1) ||
                        !desabilitaCampoEspecificoAditivoEDistrato()
                      }
                    />
                  </Col>
                </Row>

                <Row>
                  <Col cols={[12, 12, 12, 12, 12]}>
                    <Typography
                      variant='h5'
                      id='dadosEntePublico'
                      className='form-dialog-distrato__tipo-contrato-title'
                    >
                      {languageValues.cadastroContratoDadosContratoDistrato}
                    </Typography>
                  </Col>
                </Row>

                <Row>
                  <Col cols={[12, 12, 6, 6, 6]}>
                    <CustomTextField
                      id={'data-distrato'}
                      label={languageValues.cadastroContratoDataDistrato}
                      name='dataDistrato'
                      value={
                        contratosEntePublicoReducer.contratoEditing.dataDistrato
                      }
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        const value = event.target.value.trim();
                        const validation = validateDateDistrato(value);
                        setDataError(validation.error);
                        handleDataChange('dataDistrato', value);
                      }}
                      helperText={dataError ? dataError : ''}
                      error={dataError !== ''}
                      InputProps={{ inputComponent: DateMaskedInput }}
                      disabled={!desabilitaCampo()}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col cols={[12, 12, 6, 6, 6]}>
                    <CustomCheckbox
                      id={'analise-juridica'}
                      className={'form-dialog-distrato__analise-juridica'}
                      label={languageValues.flgAnaliseJuridicaAceite}
                      name='flgAnaliseJuridica'
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        handleDataChange(
                          'flgAnaliseJuridica',
                          event.target.checked
                        );
                      }}
                      checked={
                        contratosEntePublicoReducer.contratoEditing.flgAnaliseJuridica
                      }
                      disabled={!desabilitaCampo()}
                    />
                  </Col>
                </Row>
              </Box>
            </Card>
          </Box>
        </DialogContent>
        <DialogActions className='form-dialog-distrato__dialog-actions'>
          <Button
            className='form-dialog-distrato__btnClose'
            onClick={() => fechaModalEAtualizaContrato()}
          >
            {languageValues.cancelButton}
          </Button>
          <Button
            className='form-dialog-distrato__btnSave'
            onClick={() => abreModalCriacaoDistrato()}
            disabled={!validDadosEntePublicoDistrato()}
          >
            {languageValues.concluir}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default React.memo(ModalDistratoEntePublico);
